module.exports = __webpack_public_path__ + "static/media/0299_Small.82d61394.jpg";